const CURRRENCIES = {
    PYG: 'Paraguayan Guaraní',
    LRD: 'Liberian Dollar',
    GIP: 'Gibraltar Pound',
    BIF: 'Burundian Franc',
    OMR: 'Omani Rial',
    RWF: 'Rwandan Franc',
    JMD: 'Jamaican Dollar',
    PLN: 'Polish Zloty',
    LYD: 'Libyan Dinar',
    DJF: 'Djiboutian Franc',
    GMD: 'Gambian Dalasi',
    MAD: 'Moroccan Dirham',
    BDT: 'Bangladeshi Taka',
    GNF: 'Guinean Franc',
    MDL: 'Moldovan Leu',
    INR: 'Indian Rupee',
    BYR: 'Belarusian Ruble',
    TRY: 'Turkish Lira',
    SOS: 'Somali Shilling',
    NGN: 'Nigerian Naira',
    MYR: 'Malaysian Ringgit',
    BTN: 'Bhutanese Ngultrum',
    KPW: 'North Korean Won',
    BMD: 'Bermudian Dollar',
    BZD: 'Belize Dollar',
    BHD: 'Bahraini Dinar',
    LBP: 'Lebanese Pound',
    SYP: 'Syrian Pound',
    BND: 'Brunei Dollar',
    CZK: 'Czech Koruna',
    AMD: 'Armenian Dram',
    TWD: 'New Taiwan Dollar',
    FJD: 'Fiji Dollar',
    ARS: 'Argentine Peso',
    KGS: 'Kyrgyzstani Som',
    XDR: 'IMF Special Drawing Rights',
    NIO: 'Nicaraguan Córdoba',
    FKP: 'Falkland Islands Pound',
    VND: 'Vietnamese Dong',
    ZAR: 'South African Rand',
    PEN: 'Peruvian Sol',
    PGK: 'Papua New Guinean Kina',
    KMF: 'Comoro Franc',
    ILS: 'Israeli New Shekel',
    SEK: 'Swedish Krona/Kronor',
    BBD: 'Barbados Dollar',
    STD: 'São Tomé And Príncipe Dobra',
    UGX: 'Ugandan Shilling',
    MRO: 'Mauritanian Ouguiya',
    COP: 'Colombian Peso',
    MWK: 'Malawian Kwacha',
    CLP: 'Chilean Peso',
    HTG: 'Haitian Gourde',
    QAR: 'Qatari Riyal',
    PHP: 'Philippine Piso',
    TND: 'Tunisian Dinar',
    YER: 'Yemeni Rial',
    MKD: 'Macedonian Denar',
    EGP: 'Egyptian Pound',
    XCD: 'East Caribbean Dollar',
    BAM: 'Bosnia And Herzegovina Convertible',
    GYD: 'Guyanese Dollar',
    HNL: 'Honduran Lempira',
    WST: 'Samoan Tala',
    AFN: 'Afghan Afghani',
    AZN: 'Azerbaijani Manat',
    BGN: 'Bulgarian Lev',
    MZN: 'Mozambican Metical',
    RUB: 'Russian Rouble',
    ZWL: 'Zimbabwean Dollar',
    MGA: 'Malagasy Ariary',
    RON: 'Romanian Leu',
    SSP: 'South Sudanese Pound',
    VEF: 'Venezuelan Bolívar Fuerte',
    ZMW: 'Zambian Kwacha',
    GHS: 'Ghana Cedi',
    RSD: 'Serbian Dinar',
    SDG: 'Sudanese Pound',
    SRD: 'Surinam Dollar',
    TJS: 'Somoni',
    TMT: 'Turkmenistan New Manat',
    XOF: 'CFA Franc BCEAO',
    IQD: 'Iraqi Dinar',
    THB: 'Thai Baht',
    NAD: 'Namibian Dollar',
    TOP: 'Tongan Paanga',
    SCR: 'Seychelles Rupee',
    CDF: 'Congolese Franc',
    AWG: 'Aruban Florin',
    KRW: 'South Korean Won',
    GEL: 'Georgian Lari',
    MNT: 'Mongolian Tugrik',
    XAF: 'CFA Franc BEAC',
    PKR: 'Pakistani Rupee',
    DZD: 'Algerian Dinar',
    CVE: 'Cape Verde Escudo',
    GTQ: 'Guatemalan Quetzal',
    NPR: 'Nepalese Rupee',
    KYD: 'Cayman Islands Dollar',
    UZS: 'Uzbekistan Som',
    AED: 'United Arab Emirates Dirham',
    ANG: 'Netherlands Antillean Guilder',
    KWD: 'Kuwaiti Dinar',
    LKR: 'Sri Lankan Rupee',
    KHR: 'Cambodian Riel',
    PAB: 'Panamanian Balboa',
    NOK: 'Norwegian Krone',
    ETB: 'Ethiopian Birr',
    TTD: 'Trinidad And Tobago Dollar',
    IRR: 'Iranian Rial',
    LAK: 'Lao Kip',
    AOA: 'Angolan Kwanza',
    KES: 'Kenyan Shilling',
    IDR: 'Indonesian Rupiah',
    HRK: 'Croatian Kuna',
    BOB: 'Boliviano',
    CRC: 'Costa Rican Colon',
    ERN: 'Eritrean Nakfa',
    UAH: 'Ukrainian Hryvnia',
    MOP: 'Macanese Pataca',
    BSD: 'Bahamian Dollar',
    SAR: 'Saudi Riyal',
    SVC: 'Salvadoran Colón',
    SZL: 'Swazi Lilangeni',
    KZT: 'Kazakhstani Tenge',
    UYU: 'Uruguayan Peso',
    MVR: 'Maldivian Rufiyaa',
    LSL: 'Lesotho Loti',
    MMK: 'Myanma Kyat',
    SBD: 'Solomon Islands Dollar',
    JOD: 'Jordanian Dinar',
    DOP: 'Dominican Peso',
    HUF: 'Hungarian Forint',
    SLL: 'Sierra Leonean Leone',
    BWP: 'Botswana Pula',
    ISK: 'Icelandic Króna',
    SHP: 'Saint Helena Pound',
    ALL: 'Albanian Lek',
    MUR: 'Mauritian Rupee',
    CUP: 'Cuban Peso',
    TZS: 'Tanzanian Shilling',
    VUV: 'Vanuatu Vatu',
    MXN: 'Mexican Peso',
    BYN: 'Belarusian Ruble',
    STN: 'São Tomé And Príncipe Dobra',
    VES: 'Venezuela Bolívar Soberano',
    MRU: 'Mauritanian Ouguiya',
    SLE: 'Sierra Leonean Leone',
    DKK: 'Danish Krone',
    BRL: 'Brazilian Real',
    CAD: 'Canadian Dollar',
    CHF: 'Swiss Franc',
    JPY: 'Japanese Yen',
    GBP: 'Pound Sterling',
    AUD: 'Australian Dollar',
    USD: 'United States Dollar',
    CNY: 'Chinese Yuan',
    XPF: 'CFP Franc (Franc Du Pacifique)',
    SGD: 'Singapore Dollar',
    HKD: 'Hong Kong Dollar',
    NZD: 'New Zealand Dollar',
    EUR: 'Euro',
};

export default CURRRENCIES;
